import React from 'react';
import InputComponent from '../../components/input/input';
import ButtonComponent from '../../components/button/button';
import { useNavigate } from 'react-router-dom';
import DatePickerComponent from '../../components/input/input-date';
import { useUserData } from '../../shared/context/user-data-context';
import { Dayjs } from 'dayjs';
import './styles.css';
import { MenuTop } from '../../components/menu/top/menu-top';
import { getPlanUsage, IRemainingUsage } from '../../features/search/service/search-service';
import { useAuthUser } from '../../shared/hooks/use-auth-user';
import { useTranslation } from '../../shared/i18n/i18n-context';

const Register = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('register');
    const [name, setName] = React.useState('');
    const [birthDate, setBirthDate] = React.useState<Dayjs | null>(null);
    const [idRegister, setIdRegister] = React.useState('');
    const [licenseUsage, setLicenseUsage] = React.useState<IRemainingUsage | null>(null);
    const [licenseLoading, setLicenseLoading] = React.useState(true);
    const [licenseError, setLicenseError] = React.useState<string | null>(null);
    const { updateUserData } = useUserData();
    const { user, loading: userLoading } = useAuthUser();

    const hasAvailableLicenses = licenseUsage?.status.hasAvailableLicenses ?? false;
    const shouldBlockStart = userLoading || licenseLoading || !!licenseError || !hasAvailableLicenses;

    const handleNext = () => {
        if (shouldBlockStart) {
            return false;
        }

        if(name && birthDate && idRegister) {
            updateUserData({
                record_id: idRegister,
                nome: name,
                dtnasc: birthDate.format('DD/MM/YYYY')
            });

            navigate('/instruction');
        }

        return false;
    }

    React.useEffect(() => {
        const fetchLicenseUsage = async () => {
            const companyId = user?.companyId || user?.company?.id;

            if (!companyId) {
                if (!userLoading) {
                    setLicenseError(t('companyNotIdentified'));
                    setLicenseLoading(false);
                }
                return;
            }

            try {
                setLicenseLoading(true);
                setLicenseError(null);
                const usage = await getPlanUsage(companyId);
                setLicenseUsage(usage);
            } catch (error) {
                console.error('❌ Erro ao validar licenças:', error);
                setLicenseError(t('licenseValidationError'));
            } finally {
                setLicenseLoading(false);
            }
        };

        fetchLicenseUsage();
    }, [user, userLoading, t]);

    const renderLicenseAlert = () => {
        if (userLoading || licenseLoading) {
            return (
                <div className="license-alert license-alert-loading" role="status">
                    {t('checkingLicenses')}
                </div>
            );
        }

        if (licenseError) {
            return (
                <div className="license-alert" role="alert">
                    {licenseError}
                </div>
            );
        }

        if (!hasAvailableLicenses) {
            return (
                <div className="license-alert" role="alert">
                    <strong>{t('licenseLimit')}</strong>
                    <span>{t('licenseContact')}</span>
                </div>
            );
        }

        return null;
    };

    return (
        <div>
            <div className='register-container'>
                <MenuTop /> 
                {renderLicenseAlert()}
                <img src="../../../assets/logo-inteira.png" alt="Logo delay discounting"  className="logo" style={{ width: '300px', height: '200px' }}/>
                <InputComponent 
                    id="id-register-input" 
                    label={t('testId')} 
                    value={idRegister} 
                    onChange={(event) => {setIdRegister(event.target.value)}} />


                <InputComponent 
                    id="name-input" 
                    label={t('participantName')} 
                    value={name} 
                    onChange={(event) => {setName(event.target.value)}} />
                
                <DatePickerComponent 
                    label={t('birthDate')}
                    value={birthDate}
                    onChange={(event) => {setBirthDate(event)}} />
                
                <ButtonComponent
                    label={t('startTest')}
                    onClick={handleNext}
                    props={{ disabled: shouldBlockStart }}
                />
            </div>
        </div>
    )
}

export default Register;
